// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

// Get or create session ID function
const getOrCreateSessionId = (): string => {
  try {
    let sessionId = sessionStorage.getItem('session_id');
    if (!sessionId) {
      sessionId = crypto.randomUUID();
      sessionStorage.setItem('session_id', sessionId);
      console.log('📋 Created new session ID:', sessionId);
    } else {
      console.log('📋 Using existing session ID:', sessionId);
    }
    return sessionId;
  } catch (e) {
    // Fallback if sessionStorage is not available
    console.warn('⚠️ sessionStorage not available, using temporary ID');
    return 'temp_' + crypto.randomUUID();
  }
};

const sessionId = getOrCreateSessionId();
console.log('🔧 Initializing Supabase client with session ID:', sessionId);

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  },
  global: {
    headers: {
      'x-session-id': sessionId,
    }
  }
});

// Log client configuration for debugging
console.log('✅ Supabase client initialized with headers:', {
  'x-session-id': sessionId
});